module.exports = __webpack_public_path__ + "static/media/add_a_photo_black6aa82a9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/add_a_photo_black.svg
// module id = 1260
// module chunks = 0